import { CurrencyPipe, DecimalPipe, Location, UpperCasePipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { TodayTimeOrDatePipe } from '@zero/shared/ui-pipes';
import { TradingSessionComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { filter } from 'rxjs';
import { TeilrechtBase } from '../teilrecht.base';
import { TeilrechtBackLinkComponent } from './../back-link/teilrecht-back-link.component';

@Component({
  imports: [
    TranslocoPipe,
    TeilrechtBackLinkComponent,
    TradingSessionComponent,
    TodayTimeOrDatePipe,
    DecimalPipe,
    CurrencyPipe,
    ButtonComponent,
    UpperCasePipe,
  ],
  templateUrl: './teilrecht-summary.component.html',
})
export class TeilrechtSummaryComponent extends TeilrechtBase implements OnInit {
  public sessionAuthorized: boolean;
  public clicked: boolean;

  readonly #location = inject(Location);

  public override ngOnInit(): void {
    super.ngOnInit();

    this.handleRedirect();
  }

  private handleRedirect() {
    this.service.bezugsrechtData$
      .pipe(
        filter((data) => !!data?.directive),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.router.navigateByUrl(`${this.rootUrl}/${this.TEILRECHT_ROUTES.SUCCESS}`));
  }

  public sessionAuthState(value: boolean) {
    this.sessionAuthorized = value;
  }

  public back = (): void => {
    this.model.directivePreview = null;
    this.#location.back();
  };

  public placeDirective(): void {
    this.msgService.clearAllMessages();

    if (!this.model?.directivePreview || !this.sessionAuthorized) {
      this.msgService.addErrorMessage(this.translateService.translate('bezugsrecht-service.error'));
      return;
    }

    const { announcement, directivePreview } = this.model;
    this.service.placeDirective(announcement, directivePreview);
  }
}
